import * as z from 'zod';

export const roleFormSchema = z.object({
  Name: z.string().trim().min(1, { message: 'ROLE_NAME_REQUIRED' }),
  Description: z.string().optional(),
});

export type RoleFormValues = z.infer<typeof roleFormSchema>;
